import { axiosInstance } from '@libs/axios/axios';
import { apiCall } from '@shared/entity';
import { Service, ServiceCreateOrUpdateData } from './entity';

export const serviceApi = {
  getAll: () => '/api/services',
  deleteService: (serviceId: string) => `/api/services/${serviceId}`,
};

export const getServices = async (): Promise<Service[]> =>
  apiCall(async () => await axiosInstance.get(serviceApi.getAll()), 'api.service.listNotFound');

export const deleteService = async (serviceId: string): Promise<void> =>
  apiCall(
    async () => await axiosInstance.delete(serviceApi.deleteService(serviceId)),
    'api.service.deleteError',
  );

export const postCreateOrUpdateService = async (
  serviceData: ServiceCreateOrUpdateData,
): Promise<Service> =>
  apiCall(
    async () => await axiosInstance.post(serviceApi.getAll(), serviceData),
    'api.service.upsertError',
  );
